import {coerceBoolean} from "../../lib/utils";

export default {
  data() {
    return {
      preventTimerResetInEditMode: true,
    }
  },
  computed: {
    preventTimerStartInEditMode() {
      if (this.editMode && coerceBoolean(this.$$s('editMode.timer.preventStart', true))) {
        return this.preventTimerResetInEditMode
      }
      return false
    },
    autoRemoveCartItemOnTimeout() {
      const remove = coerceBoolean(this.$$s('timer.expired.items.autoRemove', true))
      const removeOnEdit = this.autoRemoveCartItemOnEditTimeout
      return this.editMode ? removeOnEdit : remove
    },
    autoRemoveCartItemOnEditTimeout() {
      return coerceBoolean(this.$$s('editMode.timer.expired.items.autoRemove', false))
    },
  }
}
